<template>
  <div style="height: 100%">
    <v-row v-if="$vuetify.breakpoint.mdAndDown" no-gutters justify="end">
      <v-col class="text-right" cols="12">
        <v-btn class="rewards-tab-mobile" :color="selectedTab == 'rewards' ? 'primary' : ''" depressed @click="onChangeTab('rewards')">{{ $t(`button.rewards`) }}</v-btn>
        <v-btn class="rewards-tab-mobile" :color="selectedTab == 'rewardsHistory' ? 'primary' : ''" depressed @click="onChangeTab('rewardsHistory')">{{ $t(`button.rewardsHistory`) }}</v-btn>
      </v-col>
    </v-row>

    <v-card :class="$vuetify.breakpoint.mdAndUp ? 'desktop_rewards_card ml-4' : 'desktop_card'" elevation="0" style="height: 100%">
      <v-card-title class="justify-space-between"></v-card-title>
      <v-row v-if="$vuetify.breakpoint.lgAndUp" no-gutters justify="end" class="px-10">
        <v-col class="text-left" cols="12">
          <v-btn class="tab-btn" :class="{ 'selected-tab': selectedTab === 'rewards', 'not-selected-tab': selectedTab !== 'rewards' }" depressed @click="onChangeTab('rewards')">
            {{ $t('button.rewards') }}
          </v-btn>
          <v-btn class="tab-btn" :class="{ 'selected-tab': selectedTab === 'rewardsHistory', 'not-selected-tab': selectedTab !== 'rewardsHistory' }" depressed @click="onChangeTab('rewardsHistory')">
            {{ $t('button.rewardsHistory') }}
          </v-btn>
        </v-col>
      </v-row>
      <v-card class="profile-detail-card rewards_card" elevation="0">
        <v-snackbar class="pa-0" style="z-index:1000 !important;top:4%" light timeout="-1" v-model="alertShow" width="fit-content" top centered>
          <v-alert
            v-model="alertShow"
            dismissible
            :icon="alertSuccess ? 'check_circle' : 'cancel'"
            class="mb-0 pa-1"
            :class="alertSuccess ? 'profile-alert-success' : 'profile-alert-failed'"
            light
            close-icon="close"
          >
            {{ alertMessage }}
          </v-alert>
        </v-snackbar>
        <v-col>
          <v-row v-if="selectedTab === 'rewards'" no-gutters justify="start" class="px-0 pa-8">
            <!--          instant rebate-->
            <v-row v-if="hasUnclaimedRebate" class="rewards-row" no-gutters>
              <v-col class="label-column" cols="2" md="4" lg="2">
                {{ $t('viptier.instantRebate') }}
                <div class="text-sm no-bold">
                  <i>({{ $t('viptier.updatedEvery15Min') }})</i>
                </div>
              </v-col>
              <v-col class="text-field-column" cols="3" md="3" lg="2">
                <v-text-field :value="totalRebate.unclaimed != null ? totalRebate.unclaimed : 0" readonly outlined dense style="background-color: transparent; width: 100%; text-align: right"></v-text-field>
              </v-col>
              <v-col class="claim-btn-column text-center" cols="3" md="2" lg="2">
                <v-btn class="tab-btn selected-tab" style="width: 100%;" :disabled="!totalRebate.unclaimed || totalRebate.unclaimed <= 0" @click="claimRebate()">
                  {{ $t(`viptier.claimNow`) }}
                </v-btn>
              </v-col>
              <!-- Desktop only (lg+): notice sits beside the Claim Now button, same row -->
              <v-col v-if="$vuetify.breakpoint.lgAndUp" class="description-column rebate-claim-notice d-flex align-center" cols="3" md="3" lg="3">
                {{ $t('viptier.rebateClaimWindowNotice') }}
              </v-col>
<!--              <v-col class="description-column text-center d-flex align-center justify-center" cols="3" md="3" lg="3">-->
<!--                {{ $t(`viptier.lastClaimed`) }}: {{ lastClaimed && lastClaimed.last_claimed ? lastClaimed.last_claimed : '&#45;&#45;' }}-->
<!--                <br />-->
<!--                {{ $t(`viptier.lastUpdated`) }}: {{ lastClaimed && lastClaimed.last_updated ? lastClaimed.last_updated : '&#45;&#45;' }}-->
<!--              </v-col>-->
<!--              <v-col class="description-column text-center d-flex align-center justify-center" cols="6" md="6" lg="6">-->
<!--                {{ $t(`viptier.autoRebate`) }}-->
<!--              </v-col>-->
            </v-row>

            <!-- Mobile/tablet only (md and below): notice on its own full-width row below the rebate row -->
            <v-row v-if="hasUnclaimedRebate && !$vuetify.breakpoint.lgAndUp" class="rebate-claim-notice-row" no-gutters>
              <v-col cols="12">
                {{ $t('viptier.rebateClaimWindowNotice') }}
              </v-col>
            </v-row>

            <v-row no-gutters v-for="item in rewardItems" :key="item.id" class="rewards-row">
              <v-col class="label-column" cols="2" md="4" lg="2">
                <span class="reward-label">{{ item.label }}</span>
              </v-col>
              <v-col class="text-field-column" cols="3" md="3" lg="2">
                <v-text-field disabled readonly outlined dense :value="item.value" class="reward-text-field"></v-text-field>
              </v-col>
              <v-col class="claim-btn-column text-center" cols="3" md="2" lg="2">
                <v-btn class="tab-btn selected-tab" style="width: 100%;" :disabled="item.buttonDisabled" @click="postRecurringBonus(item.id)">
                  {{ item.buttonText }}
                </v-btn>
              </v-col>
              <v-col class="description-column text-center d-flex align-center justify-center" cols="3" md="3" lg="3">
                <div class="reward-description">{{ item.description || '' }}</div>
              </v-col>
            </v-row>

            <!--          claim voucher-->
            <v-row class="rewards-row" no-gutters>
              <v-col class="label-column" cols="2" md="4" lg="2">
                {{ $t('label.applyVoucher') }}
              </v-col>
              <v-col class="text-field-column" cols="3" md="3" lg="2">
                <v-text-field
                  ref="codeForm"
                  v-model.trim="voucherObj.code"
                  outlined
                  dense
                  style="background-color: transparent; width: 100%; text-align: right"
                  :rules="validator.requiredRules(4, 20)"
                ></v-text-field>
              </v-col>
              <v-col class="claim-btn-column text-center" cols="3" md="2" lg="2">
                <v-btn class="tab-btn selected-tab" style="width: 100%;" @click="onClaimVoucherClick()">
                  {{ $t(`viptier.claimNow`) }}
                </v-btn>
              </v-col>
              <v-col class="description-column text-center d-flex align-center justify-center" cols="3" md="3" lg="3">
                <div class="reward-description"></div>
              </v-col>
            </v-row>

            <!--WhatsApp Support-->
            <v-row v-if="memberVipTierProgress >= 5" class="rewards-row align-center" style="justify-content: start !important;" no-gutters>
              <v-col cols="auto" class="d-flex align-center pr-4">
                <span class="whatsapp-label">
                  {{ $t('label.whatsappSupport') }}
                </span>
              </v-col>
              <v-col cols="auto" class="d-flex align-center">
                <v-btn class="whatsapp-btn d-flex align-center" style="width: 80%;" @click="openWhatsApp">
                  <img :src="`/static/svg/layout/whatsapp.svg`" alt="WhatsApp" style="width:20px; height:20px; margin-left:8px; margin-right:8px;" />
                  <span style="margin-right: 8px;">
                    {{ $t('button.whatsappSupport') }}
                  </span>
                </v-btn>
              </v-col>
            </v-row>

            <!--            Facebook Messenger Support-->
            <!--            <v-row v-if="memberVipTierProgress >= 4" class="rewards-row align-center" style="justify-content: start !important;" no-gutters>-->
            <!--              <v-col cols="auto" class="d-flex align-center pr-4">-->
            <!--                <span class="messenger-label">-->
            <!--                  {{ $t('label.messengerSupport') }}-->
            <!--                </span>-->
            <!--              </v-col>-->
            <!--              <v-col cols="auto" class="d-flex align-center">-->
            <!--                <v-btn class="messenger-btn d-flex align-center" style="width: 80%;"  @click="openMessenger">-->
            <!--                  <img :src="`/static/svg/layout/facebook.svg`" alt="Messenger" style="width:20px; height:20px; margin-left:8px; margin-right:8px;" />-->
            <!--                  <span style="margin-right: 8px;">-->
            <!--                    {{ $t('button.messengerSupport') }}-->
            <!--                  </span>-->
            <!--                </v-btn>-->
            <!--              </v-col>-->
            <!--            </v-row>-->
          </v-row>
        </v-col>
        <v-row v-if="selectedTab == 'rewardsHistory'" no-gutters align="start" justify="start" class="px-0 pa-8"></v-row>
      </v-card>
    </v-card>

    <app-dialog :dialogShow="msgDialog.show" ref="claimVoucherDetailDialog" :max-width="400" :title="voucherObj.code" :header_title="'editProfile'" :closeAction="this.onCloseClick">
      <v-row no-gutters justify="center" :class="$vuetify.breakpoint.mdAndDown ? 'px-3' : 'px-5'">
        <v-col cols="6" v-if="voucherCheck.data.bonusIsUseFreespin">
          <label class="voucher-claim-dialog-title">{{ $t(`field.freegameBet`) }}:</label>
        </v-col>
        <v-col cols="6" v-else>
          <label class="voucher-claim-dialog-title">{{ $t(`field.bonusAmount`) }}</label>
        </v-col>
        <v-col cols="6" class="text-right" v-if="voucherCheck.data.bonusIsPercentage">
          {{ voucherCheck.data.bonusPercentage }}
        </v-col>
        <v-col cols="6" class="text-right" v-else>
          {{ voucherCheck.data.bonusGivenAmount }}
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="voucherCheck.data.bonusIsUseFreespin">
          <label class="voucher-claim-dialog-title">{{ $t(`field.freegameRound`) }}:</label>
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="voucherCheck.data.bonusIsUseFreespin">
          {{ voucherCheck.data.bonusFreespinRound }}
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="voucherCheck.data.bonusIsUseFreespin">
          <label class="voucher-claim-dialog-title">{{ $t(`field.freegame`) }}</label>
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="voucherCheck.data.bonusIsUseFreespin">
          {{ voucherCheck.data.bonusFreespinGameName }}
        </v-col>
        <v-col cols="12" v-if="voucherCheck.data.bonusIsUseFreespin">
          <label style="font-size: 13px">{{ $t(`fieldHint.voucherFreespinNotify`) }}</label>
        </v-col>
        <v-col cols="6" class="mt-2 mb-6">
          <label class="voucher-claim-dialog-title">{{ $t(`field.targetTurnover`) }}</label>
        </v-col>
        <v-col cols="6" class="text-right mt-2 mb-6">
          {{ voucherCheck.data.bonusTargetRollover }}
        </v-col>
        <v-col cols="6" class="mt-2 mb-6">
          <label class="voucher-claim-dialog-title">{{ $t(`field.voucherExpires`) }}:</label>
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="voucherCheck.data.bonusIsUseFreespin">
          {{ voucherCheck.data.bonusFreespinExpired }}
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-else>
          {{ voucherCheck.data.voucher_expires }}
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="!voucherCheck.data.bonusIsUseFreespin">
          <label class="voucher-claim-dialog-title">{{ $t(`field.turnoverRequirements`) }}:</label>
        </v-col>
        <v-col cols="6" class="mt-2 mb-6" v-if="!voucherCheck.data.bonusIsUseFreespin">
          {{ voucherCheck.data.deposit_needed }}
        </v-col>
        <v-col cols="8">
          <v-btn height="auto" @click="applyVoucher" color="black" depressed class="primary-button theme-button text-capitalize pa-2 font-weight-bold yellow--text">{{ $t(`label.confirm`) }}</v-btn>
        </v-col>
      </v-row>
    </app-dialog>
  </div>
</template>
<script>
import { locale, errorCodeHelper, formValidator } from '@/util'
import { VIPTIER_GET_RECURRING_BONUS, VIPTIER_POST_RECURRING_BONUS } from '@/store/vipTier.module'
import { REWARD_POST_CHECK_IN_DAY } from '@/store/reward.module'
import {
  CLAIM_REBATE,
  REBATE_HISTORY,
  REBATE_PROVIDER,
  RESET_CLAIM_REBATE, VOUCHER_BONUS_APPLY, VOUCHER_BONUS_APPLY_RESET,
  VOUCHER_BONUS_CHECK,
  VOUCHER_BONUS_CHECK_RESET
} from '@/store/bonus.module'
import { ROUTE_NAME } from '@/constants/route.constants'
import moment from 'moment'
import { getYesterdayBdRangeInGmt8 } from '@/util/bd-timezone'
import { validator } from '@johnnyguan/vue-captcha-code'
export default {
  name: 'vipRewards',
  components: {
    //
  },
  data: () => ({
    msgDialog: {
      show: false,
      title: '',
      msg: ''
    },
    validator: formValidator,
    voucherObj: {
      code: ''
    },
    voucherCheck: {
      data: {}
    },
    codeIsValid: false,
    alertShow: false,
    alertSuccess: false,
    alertMessage: '',
    selectedTab: 'rewards',
    rewardItems: [
      // { label: 'Instant Rebate', value: '', id: 'instant-rebate', description: '' },
      { label: 'Monthly Bonus', value: '', id: 'monthly-bonus', description: '' },
      { label: 'Weekly Bonus', value: '', id: 'weekly-bonus', description: '' },
      { label: 'Daily Bonus', value: '', id: 'daily-bonus', description: '' }
      // { label: 'Voucher', value: '', id: 'voucher', description: '' }
    ],
    timerInterval: null
  }),
  created() {
    this.getRecurringBonus()
    this.getRebateHistory()
  },
  computed: {
    voucherCheckResult() {
      return this.$store.state.bonus.checkVoucherResponse.complete
    },
    voucherApplyResult() {
      return this.$store.state.bonus.applyVoucherResponse.complete
    },
    recurringBonusList() {
      return this.$store.state.vipTier.recurringBonus
    },
    recurringBonusResponse() {
      return this.$store.state.vipTier.recurringBonusResponse
    },
    claimRebateResult() {
      return this.$store.state.bonus.claimRebateResult.complete
    },
    totalRebate() {
      return this.$store.state.bonus.rebateHistory.totalRebate
    },
    hasUnclaimedRebate() {
      return this.totalRebate.unclaimed > 0
    },
    lastClaimed() {
      return this.$store.state.bonus.rebateHistory.lastClaimed
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing.level_sequence
    }
  },
  watch: {
    voucherApplyResult() {
      if (this.$store.state.bonus.applyVoucherResponse.complete) {
        this.openResultDialog(this.$store.state.bonus.applyVoucherResponse)
      }
    },
    voucherCheckResult() {
      if (this.$store.state.bonus.checkVoucherResponse.complete) {
        this.voucherCheck = this.$store.state.bonus.checkVoucherResponse
        this.openConfirmDialog(this.voucherCheck)
      }
    },
    recurringBonusList: {
      immediate: true, // Trigger on initial load
      handler(newList) {
        if (newList) {
          this.mapRecurrenceToRewardItems()
        }
      }
    },
    recurringBonusResponse() {
      if (this.$store.state.vipTier.recurringBonusResponse) {
        this.postRecurringBonusComplete(this.$store.state.vipTier.recurringBonusResponse)
      }
    },
    claimRebateResult() {
      if (this.$store.state.bonus.claimRebateResult.complete) {
        this.claimRebateResponse(this.$store.state.bonus.claimRebateResult)
      }
    }
  },
  methods: {
    onClaimVoucherClick() {
      if (this.$refs.codeForm.validate()) {
        const voucherObj = this.voucherObj
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK}`, {
          voucherObj
        })
      }
    },
    openResultDialog(result) {
      if (result.code != 0 && !result.success) {
        this.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(result.code))
      } else {
        this.$parent.openAlert(true, locale.getMessage(`message.voucherBonusApplied`))
      }
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      this.$store.dispatch(`${VOUCHER_BONUS_APPLY_RESET}`)
    },
    openConfirmDialog(result) {
      if (result.code != 0 && !result.success) {
        this.$parent.openAlert(false, errorCodeHelper.getErrorCodeDesc(result.code))
        this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      } else {
        this.msgDialog.show = true
      }
    },
    applyVoucher() {
      const voucherObj = this.voucherObj
      this.$store.dispatch(`${VOUCHER_BONUS_APPLY}`, {
        voucherObj
      })
      this.msgDialog.show = false
    },
    onCloseClick() {
      this.$store.dispatch(`${VOUCHER_BONUS_CHECK_RESET}`)
      this.msgDialog.show = false
    },
    getRebateHistory() {
      // Bhaggo: 24h claim window — show only yesterday's BD-day rebate.
      // Backend gates by brand; FE sends the explicit range plus claimWindow=true
      // so the API knows this is the claim widget (not the history listing).
      const range = getYesterdayBdRangeInGmt8()
      let obj = {
        startTime: range.startTime,
        endTime: range.endTime,
        page: 1,
        size: 10000,
        claimWindow: true
      }
      this.$store.dispatch(`${REBATE_HISTORY}`, { obj })
    },
    claimRebate() {
      const range = getYesterdayBdRangeInGmt8()
      const obj = {
        startTime: range.startTime,
        endTime: range.endTime
      }
      this.$store.dispatch(`${CLAIM_REBATE}`, { obj })
    },
    claimRebateResponse(result) {
      if (result.success && result.code == 0) {
        this.openAlert(true, locale.getMessage(`message.rebateClaimedSuccess`))
      } else {
        this.openAlert(false, locale.getMessage(`message.rebateClaimedFailed`))
      }
      this.getRebateHistory()
      this.getRebateProvider()
      this.$store.dispatch(`${RESET_CLAIM_REBATE}`)
    },
    getRecurringBonus() {
      this.$store.dispatch(`${VIPTIER_GET_RECURRING_BONUS}`)
    },
    postRecurringBonus(id) {
      if (id === 'monthly-bonus') {
        id = 3
      } else if (id === 'weekly-bonus') {
        id = 2
      } else if (id === 'daily-bonus') {
        id = 1
      } else if (id === 'voucher') {
        this.onClaimVoucherClick(vCode)
        return
      }
      let obj = {
        type: id
      }
      this.$store.dispatch(`${VIPTIER_POST_RECURRING_BONUS}`, { obj })
    },
    postRecurringBonusComplete(res) {
      if (res.success && res.code === 0 && res.data.amount != null && res.data.remark != null) {
        this.openAlert(true, 'Claimed Successfully! ' + res.data.remark)
        this.getRecurringBonus()
      } else {
        if (res.error) {
          if (res.error.type) {
            this.openAlert(false, 'Claim Failed! ' + res.error.type[0])
          }
        } else if (res.data.original && res.data.original.message) {
          this.openAlert(false, 'Claim Failed! ' + res.data.original.message + ' to claim')
        }
        this.getRecurringBonus()
      }
    },
    onChangeTab(tab) {
      this.selectedTab = tab
      if (tab === 'rewards') {
        //
      } else {
        //
        this.$router.push({
          name: ROUTE_NAME.REBATE_HISTORY
        })
      }
    },
    mapRecurrenceToRewardItems() {
      let claimNowTxt = locale.getMessage(`viptier.claimNow`)

      this.rewardItems = this.recurringBonusList.map(item => {
        let description = ''
        let buttonText = claimNowTxt
        let buttonDisabled = false

        if (item.vip_bonus_banned) {
          buttonText = locale.getMessage("viptier.notEligibleContactCs")
          buttonDisabled = true
        } else if (!item.eligible) {
          buttonText = locale.getMessage("viptier.notEligible")
          buttonDisabled = true
        }

        // Disable button based on claimable status
        if (!item.is_claimable) {
          buttonDisabled = true

          if (item.claim_start_at && moment(item.claim_start_at).isAfter(moment())) {
            description = `Claim Start At:\n${item.claim_start_at}`
          }

          // Description if current vip level < min_eligible_level
          if (this.memberVipTierProgress < item.min_eligible_level) {
            description = `AVAILABLE for VIP LEVEL ${item.min_eligible_level} & above`
          }
        }

        return {
          label: item.type === 3 ? locale.getMessage(`viptier.monthlyBonus`) : item.type === 2 ? locale.getMessage(`viptier.weeklyBonus`) : locale.getMessage(`viptier.dailyBonus`),
          value: `৳${item.amount.toLocaleString()}`,
          id: item.type === 3 ? 'monthly-bonus' : item.type === 2 ? 'weekly-bonus' : 'daily-bonus',
          description: description || '',
          buttonText,
          buttonDisabled
        }
      })
      // this.rewardItems.push(
      //   // { label: 'Instant Rebate', value: '0', id: 'dummy-1', description: '', buttonText: claimNowTxt, buttonDisabled: false },
      //   // { label: locale.getMessage(`viptier.voucher`), value: 'Voucher Code', id: 'voucher', description: '', buttonText: claimNowTxt, buttonDisabled: false }
      // )
      this.rewardItems.sort((a, b) => {
        const order = ['Instant Rebate', 'monthly-bonus', 'weekly-bonus', 'daily-bonus', 'Voucher']

        const indexA = order.indexOf(a.id)
        const indexB = order.indexOf(b.id)
        return (indexA === -1 ? Number.MAX_VALUE : indexA) - (indexB === -1 ? Number.MAX_VALUE : indexB)
      })
    },
    fetchRecurringBonusList() {
      this.mapRecurrenceToRewardItems()
    },
    openAlert(success, msg) {
      this.alertSuccess = success
      this.alertMessage = msg
      this.alertShow = true
    },
    startTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
      }
      this.timerInterval = setInterval(() => {
        const now = new Date()
        const upcomingBonus = this.recurringBonusList.find(item => {
          const claimStartAt = new Date(item.claim_start_at)
          return !item.is_claimable && now >= claimStartAt
        })
        if (upcomingBonus) {
          // console.log('A bonus is now claimable:', upcomingBonus)
          this.getRecurringBonus()
          clearInterval(this.timerInterval) // Stop the timer
        }
      }, 1000) // Check every second
    },
    openWhatsApp() {
      window.open('https://heylink.me/bhaggovip/', '_blank')
    },
    openMessenger() {
      window.open('https://m.me/@bhaggovip', '_blank')
    }
  },
  mounted() {
    this.fetchRecurringBonusList()
    this.startTimer()
  },
  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-btn {
  border-style: solid !important;
  border-color: #7a7a7a !important;
}

.selected-tab {
  border-radius: 12px;
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  background-color: #1b3000 !important;
  text-transform: capitalize;
  color: #f6ff00 !important;
  white-space: normal !important;
  height: auto !important;
  min-height: 36px;
  line-height: 1.3;

  ::v-deep .v-btn__content {
    white-space: normal !important;
    word-break: break-word;
    line-height: 1.3;
    max-width: 100%;
    flex-wrap: wrap;
  }
}

.not-selected-tab {
  border-radius: 12px;
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  color: #000000 !important;
  border-color: #7a7a7a;
  background-color: #e9e9e9 !important;
  text-transform: capitalize;
}

.desktop_rewards_card {
  border-radius: 12px !important;
  //height: 660px !important;
  min-height: 700px;
  font-family: 'Roboto', sans-serif;
}

.rewards_card {
  //height: 80%;
  overflow-x: hidden;
  overflow-y: auto;

  /* Mobile Styles */
  @media (max-width: 960px) {
    .rewards_card {
      height: 80%;
      overflow-x: hidden;
      overflow-y: hidden;
    }
  }
}

.rewards-tab {
  width: 150px;
  margin-right: 16px;
  padding: 10px;
  background-color: #fff;
  text-transform: capitalize;
}

.rewards-tab-mobile {
  width: 120px;
  margin-right: 10px;
  padding: 5px;
  background-color: #fff;
  text-transform: capitalize;
}

.rewards-row {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 5px 5px 20px;

  @media (min-width: 1280px) {
    justify-content: space-between;
    margin: 10px 15px 30px;
  }

  @media (min-width: 960px) and (max-width: 1280px) {
    justify-content: space-evenly;
    margin: 5px 10px;
    column-gap: 10px;
    padding: 5px 10px;

    .label-column {
      flex: 1;
      max-width: 25%;
      text-align: left;
      font-size: 0.9rem;
    }
    .text-field-column {
      flex: 1;
      max-width: 25%;
    }
    .claim-btn-column {
      flex: 1;
      max-width: 25%;
      button {
        font-size: 0.8rem;
      }
    }
    .description-column {
      flex: 1;
      max-width: 25%;
      font-size: 0.8rem;
      text-align: center;
    }
  }

  @media (min-width: 1600px) {
    justify-content: flex-start;
    column-gap: 20px;
  }

  @media (min-width: 2000px) {
    justify-content: flex-start;
    column-gap: 40px;
    margin: 15px 20px 50px;
    font-size: 1.2rem;
    padding: 10px 20px;
  }

  @media (min-width: 2300px) {
    justify-content: flex-start;
    column-gap: 40px;
    margin: 15px 20px 50px;
    font-size: 1.2rem;
    padding: 10px 20px;
  }

  @media (min-width: 2560px) {
    justify-content: center;
    max-width: 1920px;
    margin: 0 auto;
    padding: 20px 30px;
    column-gap: 50px;
    font-size: 1.4rem;
  }

  @media (min-width: 3840px) {
    max-width: 2560px;
    justify-content: center;
    column-gap: 60px;
    font-size: 1.5rem;
    margin: 0 auto;
    padding: 30px 40px;
  }
}

.label-column {
  font-weight: bold;
  margin-right: 10px;
  text-align: left;
  width: 20%;

  .no-bold.text-sm {
    font-weight: normal;
    font-size: small;
  }
}

.text-field-column {
  align-content: center;
  height: 40px;
  line-height: 40px;
  width: 30%;
  text-align: right !important;
}

.claim-btn-column {
  min-height: 40px;
  height: auto;
  text-align: center;
  width: 15%;
}

.description-column {
  height: 40px;
  font-size: small;
  color: #626262;
  line-height: 20px;
  white-space: normal;
  text-align: right;
  width: 35%;
}

/* Desktop (lg+): notice beside the Claim Now button on the same row */
.rebate-claim-notice {
  height: auto !important;
  line-height: 1.4 !important;
  text-align: left !important;
  font-size: 0.9rem;
  color: #626262;
  padding: 0 12px;
  font-style: italic;
}

/* Mobile/tablet only: notice on its own full-width row below the rebate row */
.rebate-claim-notice-row {
  margin: -10px 5px 20px;
  font-size: 0.85rem;
  color: #626262;
  font-style: italic;
  line-height: 1.4;
}

.reward-text-field {
  background-color: transparent;
  width: 100%;
  align-content: center;
  text-align: right !important;
}

.reward-description {
  color: #7a7a7a;
  min-width: 100px;

  // Workaround where multiple v-row in same line
  @media (min-width: 2560px) {
    min-width: 300px;
  }
  @media (min-width: 3040px) {
    min-width: 600px;
  }
}

.whatsapp-label {
  color: #e53935;
  font-size: 1.4rem;
  font-weight: bold;
}

.whatsapp-btn {
  background-color: #25d366 !important;
  color: #fff !important;
  font-weight: bold;
  border-radius: 8px;
  text-transform: none;
  font-size: 1rem;
  padding: 8px 16px;
}

.messenger-label {
  color: #e53935;
  font-size: 1.4rem;
  font-weight: bold;
}

.messenger-btn {
  background-color: transparent !important;
  color: #1877f2 !important;
  border: 2px solid #1877f2 !important;
  font-weight: bold;
  border-radius: 8px;
  text-transform: none;
  font-size: 1rem;
  padding: 8px 16px;
  transition: all 0.3s ease;
}

.messenger-btn:hover {
  background-color: #1877f2 !important;
  color: #fff !important;
}

@media (max-width: 425px) {
  .whatsapp-label {
    font-size: 0.85rem;
  }
  .whatsapp-btn {
    font-size: 0.85rem;
    padding: 6px 12px;
    min-width: auto;
  }
  .messenger-label {
    font-size: 0.85rem;
  }
  .messenger-btn {
    font-size: 0.85rem;
    padding: 6px 12px;
    min-width: auto;
  }
}
</style>
